// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yZEQv","logo":"Footer_logo__qDJde","creator":"Footer_creator__qVJiD"};